<div class="d-flex flex-row justify-content-center">
  <div>
    <div class="stat-location">{{'_Lobby_Status_Today_Service_Summary_Text_' | translate }} <span>{{locationName}}</span></div>
    <div class="cc-card d-flex flex-row justify-content-around stats-container">

      <app-lobby-status-tile title="{{'_Lobby_Status_Visitors_Waiting_Text_' | translate }}" [value]="statusBarData.visitorsWaiting"
        [icon]="'assets/images/icon/waitingroom-stats-icon.svg'"></app-lobby-status-tile>

      <div class="stats-seperator"></div>

      <div class="d-flex flex-row align-items-center stats-item">
       
        <img src="assets/images/icon/time-stats-icon.svg" alt="Average Wait Time icon" />
        <p class="stats-count"> 
            <span *ngIf="statusBarData.avgWaitTime > 0 ; else staticTime">
              {{statusBarData.avgWaitTime * 1000 | date: "HH:mm:ss":"UTC"}}            
            </span>
            <ng-template #staticTime>
              {{statusBarData.avgWaitTime}}
            </ng-template>
          
        </p>
        <p class="stats-title">{{'_General_Average_Wait_Time_Text_' | translate }}</p>
      </div>

      <div class="stats-seperator"></div>

      <app-lobby-status-tile title="{{'_Lobby_Status_Staff_Signed_In_Text_' | translate }}" [value]="statusBarData.staffSignedIn"
        [icon]="'assets/images/icon/signin-stats-icon.svg'"></app-lobby-status-tile>

      <div class="stats-seperator"></div>

      <app-lobby-status-tile title="{{'_Lobby_Status_Visitors_Served_Text_' | translate }}" [value]="statusBarData.visitorServed"
        [icon]="'assets/images/icon/application-stats-icon.svg'"></app-lobby-status-tile>
    </div>
  </div>
</div>